import { render } from "./MegaphoneIcon.vue?vue&type=template&id=34b4d0c7"
import script from "./MegaphoneIcon.vue?vue&type=script&lang=js"
export * from "./MegaphoneIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__